import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { DashboardStatisticsPeriodListItem } from '@/models/statistics/dashboard-statistics-period-list.model';

export default class GetDashboardStatisticsPeriodListRequest
  extends ApiResourceMethod<DashboardStatisticsPeriodListItem[]> {
  public perform(whitelabelSlug: string): Promise<DashboardStatisticsPeriodListItem[]> {
    return this.performer.requestWithMapper(
      {
        url: `${whitelabelSlug}/dictionary/dashboardStatisticsPeriod`,
      },
      ({ data }: BaseResponse<DashboardStatisticsPeriodListItem[]>): DashboardStatisticsPeriodListItem[] => data,
    );
  }
}
